import "./Attendance.css";
import HeaderElement from "../../../components/HeaderElement/HeaderElement";
import AtButton from "../../../components/Attendance/AtButton/AtButton";
import AtQueuePopUp from "../../../components/Attendance/AtQueuePopUp/AtQueuePopUp";
import AdminControls from "../../../components/Attendance/AdminControls";
import MeetingTypeModal from "../../../components/Attendance/MeetingTypeModal";
import AttendancePrompts from "../../../components/Attendance/AttendancePrompts";
import { useAttendanceLogic } from "./useAttendanceLogic";
import { useUI } from "../../../hooks/usePermission";

export default function Attendance({ user }) {
  const canManageQueue = useUI('action.attendance.queue');
  const canManageAttendance = useUI('action.attendance.manage');

  const {
    status,
    active,
    waitlist,
    loading,
    popup,
    queueOpen,
    setQueueOpen,
    retryPrompt,
    setRetryPrompt,
    choicePrompt,
    setChoicePrompt,
    onlinePrompt,
    setOnlinePrompt,
    meetingTypeSelectorOpen,
    isOnlineMode,
    setIsOnlineMode,
    error,
    closePopup,
    closeSelectorModal,
    handleQueueAdd,
    validateWithLocation,
    handleAttend,
    startAttendance,
    toggleAttendance,
    showQueue,
    handleValidation,
    t
  } = useAttendanceLogic(user);

  const buttonText = loading
    ? t.buttonLoading
    : !active
    ? t.buttonNoSession
    : status === "attending"
    ? t.buttonPresent
    : status === "waiting"
    ? t.buttonWaiting
    : t.buttonAttend;

  const buttonColor = loading || !active
    ? "var(--light-gray)"
    : status === "attending"
    ? "var(--green)"
    : status === "waiting"
    ? "var(--orange)"
    : "var(--eestec-red)";

  return (
    <div>
      <HeaderElement headerText={t.title} />
      <div className="attendanceWrapper">
        <AtButton
          text={buttonText}
          handleClick={handleAttend}
          radius="22px"
          color={buttonColor}
          disabled={loading}
        />

        <AdminControls
          canManageAttendance={canManageAttendance}
          canManageQueue={canManageQueue}
          active={active}
          toggleAttendance={toggleAttendance}
          showQueue={showQueue}
          waitlistCount={waitlist.length}
          loading={loading}
        />

        <AttendancePrompts
          popup={popup}
          closePopup={closePopup}
          retryPrompt={retryPrompt}
          setRetryPrompt={setRetryPrompt}
          choicePrompt={choicePrompt}
          setChoicePrompt={setChoicePrompt}
          onlinePrompt={onlinePrompt}
          setOnlinePrompt={setOnlinePrompt}
          validateWithLocation={validateWithLocation}
          handleQueueAdd={handleQueueAdd}
          t={t}
        />

        {queueOpen && (
          <AtQueuePopUp
            message={waitlist.length > 0 ? " " : t.queueEmpty}
            type="info"
            onClose={() => setQueueOpen(false)}
            onLineButtonClick={handleValidation}
            waitlist={waitlist}
          />
        )}

        <MeetingTypeModal
          isOpen={meetingTypeSelectorOpen}
          onClose={closeSelectorModal}
          isOnlineMode={isOnlineMode}
          setIsOnlineMode={setIsOnlineMode}
          loading={loading}
          error={error}
          startAttendance={startAttendance}
          t={t}
        />
      </div>
    </div>
  );
}